<template>
  <div class="text-right">
    <Menu as="div" class="relative inline-block text-left">
      <div>
        <MenuButton
            class="btn btn-outline-dark inline-flex w-full justify-center rounded-md bg-black/20 px-4 py-2 text-xs font-medium text-white hover:bg-black/30 gap-2 items-center h-[32px]"
        >
          {{ buttonLabel }}
          <Icon icon="radix-icons:caret-down"/>
        </MenuButton>
      </div>

      <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
      >
        <MenuItems
            class="absolute right-0 mt-2 min-w-72 origin-top-right rounded-lg bg-slate-800 z-10 shadow-2xl border border-slate-600">
          <div class="p-2 divide-y divide-slate-700">
            <MenuItem
                v-for="[key, value] of Object.entries(summary)"
                :key="key"
                v-slot="{ active }"
            >
              <div class="flex flex-col justify-between w-full group p-2 text-xs gap-1"
                   :class="active ? 'bg-slate-700/20 text-slate-100' : 'text-slate-200'">
                <div class="flex flex-row justify-between items-end gap-1">
                  <p>{{ key }}</p>
                  <p>{{ formatPrice(value.toFixed(2)) }} {{key==='Value' ? ' $' : ''}}</p>
                </div>
              </div>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script setup>
import {Menu, MenuButton, MenuItems, MenuItem} from '@headlessui/vue'
import {Icon} from '@iconify/vue'
import {computed} from 'vue'
import {formatPrice} from '@/utils/priceFormatter.js'
import {object} from "yup";

const props = defineProps({
  buttonLabel: {type: String, default: 'Summary'},
  orders: {type: Array},
})

const summary = computed(() => {
  let sumAmount = 0
  let sumValue = 0

  props.orders.forEach(order => {
    sumAmount += order.amount
    sumValue += order.value
  })

  return {
    Amount: sumAmount,
    Value: sumValue,
    Records: props.orders.length
  }
})
</script>